// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"9ed7cbf7","182":"9403be05"}[chunkId] + ".chunk.js";
};